import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { Clipboard } from '@angular/cdk/clipboard';
import { Router } from '@angular/router';



@Component({
  selector: 'app-mentor-create-course-list',
  templateUrl: './mentor-create-course-list.component.html',
  styleUrls: ['./mentor-create-course-list.component.scss']
})
export class MentorCreateCourseListComponent implements OnInit {
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  user_name: any;
  user_id: any;
  tableshow: boolean = false;
  coursedatas: any;
  mentorcourse: FormGroup;
  selectedCourse: any;
  imageSrc: string | ArrayBuffer | null = null;
  dtOptions: DataTables.Settings = {};
  date: any;
  uploadFiles: any = '';
  spinner:boolean = false;
  constructor(
    private fb: FormBuilder,
    private ApiService: ApiServiceService,
    private spinnerService: NgxSpinnerService,
    public datepipe: DatePipe,
    private clipboard: Clipboard,private router:Router
  ) {
    this.user_name = this.ApiService.user_details.firstname;
    this.user_id = this.ApiService.user_details.id;
    this.mentorcourse = this.fb.group({
      mentor_id: [''],
      mentor_name: [''],
      mentor_number: [''],
      mentor_email: [''],
      mentor_district: [''],
      course_name: [''],
      course_topic: [''],
      course_des: [''],
      course_date: [''],
      course_time: [''],
      online_meet_link: [''],
      comments: [''],
      image:['',[this.imageSizeValidator(60000)]],
    });
  }

  ngOnInit(): void {
    this.handleBackButtonForModal();

    this.user_id = this.ApiService.user_details.id;
    this.date = new Date();
    this.showSpinner();

    this.dtOptions = {
      pagingType: 'full_numbers'
    };
    this.getCourseById();
  }

  getCourseById() {
    this.ApiService.get_all_courese().subscribe((data: any) => {
    
      this.coursedatas = data;
      this.tableshow = true;
      
      this.spinnerService.hide();
    });
  }
  // onFileSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files[0]) {
  //     const file = input.files[0];
  //     const reader = new FileReader();

  //     reader.onload = () => {
  //       this.imageSrc = reader.result;
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // }
  selectFiles(event: any) {
    if (event.target.files[0].size < 60000) {
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles = da;
      });
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "The size should be less than 60kb",
        showConfirmButton: false,
        timer: 1500
      });
      $('#file').val('');
      
      // Mark the 'image' form control as invalid
      this.mentorcourse.get('image')?.setErrors({ 'imageSizeExceeded': true });
    }
  }
  imageSizeValidator(maxSize: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && control.value.size) {
        const fileSize = control.value.size; // Get the size of the file
        if (fileSize > maxSize) {
          return { 'imageSizeExceeded': true }; // Return an error if the size exceeds the limit
        }
      }
      return null; // Return null if the size is within the limit
    };
  }
 
  

  public showSpinner(): void {
    this.spinnerService.show();
  }

  PatchMentorCourse(coursedata: any): void {
    this.mentorcourse.patchValue({
      mentor_id: coursedata.user_id,
      mentor_name: coursedata.first_name,
      mentor_number: coursedata.number,
      mentor_email: coursedata.email,
      mentor_district: coursedata.district,
      course_name: coursedata.course_name,
      course_topic: coursedata.course_topic,
      course_des: coursedata.course_des,
      course_date: coursedata.course_date,
      course_time: coursedata.course_time,
      online_meet_link: coursedata.online_meet_link,
      comments: coursedata.comment,
      
    });
  }

  onSelectCourse(coursedata: any): void {
    this.selectedCourse = coursedata;
    this.PatchMentorCourse(this.selectedCourse);
  }

  approveCourse(): void {
    this.spinnerService.show();
    const selectedImage = this.uploadFiles ? this.uploadFiles : 'images/course.jpg';
  
    const approvalData = {
      mentor_id: this.mentorcourse.value.mentor_id,
      mentor_course_id: this.selectedCourse.id, 
      approved: true,
      course_name: this.mentorcourse.value.course_name,
      course_topic: this.mentorcourse.value.course_topic,
      course_des: this.mentorcourse.value.course_des,
      course_date: this.mentorcourse.value.course_date,
      course_time: this.mentorcourse.value.course_time,
      online_meet_link: this.mentorcourse.value.online_meet_link,
      comments: this.mentorcourse.value.comments,
      image:selectedImage ,
    };
    this.spinner = true;
    this.ApiService.approved_coure(approvalData).subscribe(
      response => {
        this.spinner = false;
        this.spinnerService.hide();
        Swal.fire({
          title: "Course has been Approved successfully!",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: '#015792',
          iconColor: "#015792"
        }).then(() => {
          window.location.reload();
        });
      },
      error => {
        console.error('Error approving course:', error);
      }
    );
  }
 
  rejectCourse() {
    const selectedImage = this.uploadFiles ? this.uploadFiles : 'images/course.jpg';
    
    const courseData = {
        mentor_id: this.mentorcourse.value.mentor_id,
        mentor_course_id: this.selectedCourse.id, 
        approved: false,   
        course_name: this.mentorcourse.value.course_name,
        course_topic: this.mentorcourse.value.course_topic,
        course_des: this.mentorcourse.value.course_des,
        course_date: this.mentorcourse.value.course_date,
        course_time: this.mentorcourse.value.course_time,
        online_meet_link: this.mentorcourse.value.online_meet_link,
        comments: this.mentorcourse.value.comments,
        image:selectedImage ,
    };
    this.spinnerService.show();
    this.spinner = true;
    this.ApiService.rejectCourse(courseData).subscribe(
        response => {
          this.spinner = false; 
          this.spinnerService.hide();
            Swal.fire({
                title: "Course has been rejected!",
                icon: "success",
                confirmButtonText: "Okay",
                confirmButtonColor: '#dc3545',
                iconColor: "#dc3545"
            }).then(() => {
                window.location.reload(); // Reload the page to reflect the changes
            });
        },
        error => {
            console.error('Error rejecting course:', error);
        }
    );
}

copyToClipboard(): void {
  const onlineMeetLink = this.mentorcourse.get('online_meet_link')?.value;
  if (onlineMeetLink) {
    this.clipboard.copy(onlineMeetLink);
    // Swal.fire({
    //   title: "Link copied to clipboard!",
    //   icon: "success",
    //   confirmButtonText: "Okay",
    //   confirmButtonColor: '#015792',
    //   iconColor: "#015792"
    // });
    const copyMessageElement = document.getElementById('copyMessage');
    if (copyMessageElement) {
      copyMessageElement.style.display = 'inline';  // Show the message
      setTimeout(() => {
        copyMessageElement.style.display = 'none'; // Hide the message after 2 seconds
      }, 2000);
    }
  }
}

handleBackButtonForModal() {
  // Push initial state to history
  history.pushState(null, '', window.location.href);

  window.onpopstate = () => {
    const modal = document.querySelector('.modal.show') as HTMLElement;
    if (modal) {
      // Find the close button inside the modal and trigger a click event on it
      const closeButton = modal.querySelector('.close') as HTMLElement;
      if (closeButton) {
        closeButton.click();
      }

      // Prevent default back navigation
      history.pushState(null, '', window.location.href);
    } else {
      // Allow back navigation as usual if modal is not open
      this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
    }
  };
}
ngOnDestroy(): void {
  // Cleanup event listener to avoid memory leaks
  window.onpopstate = null;
}

}
